import { registerPlugin } from '@capacitor/core';

const SecureCredential = registerPlugin('ZodiacusSecureCredential');

export const nativeSecureCredential = Object.freeze({
  async getCredential() {
    const result = await SecureCredential.getCredential();
    return typeof result?.value === 'string' && result.value ? result.value : null;
  },
  async setCredential(value) {
    if (!value) throw new Error('secure_credential_required');
    await SecureCredential.setCredential({ value });
  },
  async removeCredential() {
    await SecureCredential.removeCredential();
  },
});
